import gql from 'graphql-tag';

export default gql`
  fragment industryTypeFragment on IndustryTypeType {
    id
    name
  }
`;
